/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paragraph
 */

export { default as Paragraph } from './paragraph';
export { default as ParagraphButtonUI } from './paragraphbuttonui';
